import React, { useState } from 'react'
import styles from './Gt2Tabs.module.css'
import { Tick } from './Gt2SpecsTabs'

// GT-2 compatibility: the lists that apply to the GT-2 chassis — wheelbases per
// mounting option (front or bottom), the seats the side brackets accept, and
// pedals.
// Order is deliberately mixed rather than alphabetical, with the VRS entries
// pinned to the top. Fixed (not randomised at runtime) so server and client
// render identically.
const FRONT_MOUNT = [
  'VRS DFP15',
  'VRS DFP20 / uDFP20',
  'Simucube 2 & Simucube 3 Sport, Pro, Ultimate',
  'MiGe 130ST (small, big)',
  'Other MiGE motor-type wheelbases',
  'Asetek La Prima, Forte, Invicta',
  'VNM wheelbases',
  'Simagic Alpha, Alpha Mini, Alpha U, Evo series',
  'Bodnar 50 series',
  'Lenze MCS12 series',
  'AccuForce Pro V2 Steering System',
]

// Bottom-mount plate: the direct-drive and belt bases that bolt under the
// chassis rather than to the front face.
const BOTTOM_MOUNT = [
  'Moza R5, R9, R12, R16, R21',
  'Fanatec Clubsport Wheel V1, V2, V2.5',
  'Fanatec CSL, CSL DD, CSW',
  'Fanatec DD1, DD1 QR2, DD2, GT DD Pro',
  'Asetek Forte 18Nm & Invicta 27Nm Direct Drive',
  'Simagic M10 Wheel Base',
  'AccuForce V1',
  'AccuForce Pro V2',
  'Logitech PRO DD11, Pro Racing Wheel Direct Drive',
  'Logitech G25, G27, G29, G920 / G923',
  'Thrustmaster (all wheel bases)',
]

// Side mounting brackets: the GT-2 takes the VRS GT-2 Seat and any aftermarket
// bucket within these dimensions.
const SEAT_LEAD = 'Fits any Sparco, Recaro, Bride, etc.'
const SEATS = [
  ['Side distance between seat mounting points (min/max)', '285 – 295 mm (11.2 – 11.6 inch)'],
  ['Seat width at mounting points (min/max)', '390 – 520 mm (15.3 – 20.5 inch)'],
  ['Mounting points', 'M8'],
  ['Angle adjustment', 'Tilt 0 – 18°'],
]

const PEDALS = [
  'VRS DirectForce Pro',
  'Heusinkveld Pro, Sprint, Ultimate, Ultimate+',
  'Simucube Active Pedal',
  'Moza CRP, SR-P',
  'Fanatec Clubsport V3, Inverted V3',
  'Simagic P1000 Pedals',
  'Asetek Invicta & Forte',
  'Logitech Pro Pedals (needs connector not included)',
  'Meca Cup Pedals',
  'Fanatec Elite pedals',
  'Simtrecs ProPedal GT',
  'Simagic P2000 Pedals (with Simagic baseplate)',
  'Thrustmaster T300, T-LCM, T3PA (needs connector not included)',
  'SimCoaches P1-3',
  'Fanatec CSL/CSL Elite Pedals LC',
  'Simgrade R7 Pedal Set',
  'SimWorkx Pro pedals',
  'Logitech G25, G27, G920 (needs connector not included)',
  'Simgrade VX-PRO Pedals',
]

const TABS = [
  { id: 'front', label: 'Front mount wheelbases', items: FRONT_MOUNT },
  { id: 'bottom', label: 'Bottom mount wheelbases', items: BOTTOM_MOUNT },
  { id: 'seats', label: 'Supported seats', lead: SEAT_LEAD, specs: SEATS },
  { id: 'pedals', label: 'Pedals compatibility', items: PEDALS },
]

function Gt2Compatibility() {
  const [tab, setTab] = useState('front')
  const active = TABS.find((t) => t.id === tab) || TABS[0]

  return (
    <section className={styles.wrap} aria-label="GT-2 Cockpit compatibility">
      <div className={styles.inner}>
        <h2 className={styles.heading}>GT-2 Cockpit Compatibility</h2>
        <div className={styles.tabs} role="tablist">
          {TABS.map((t) => (
            <button
              type="button"
              key={t.id}
              role="tab"
              aria-selected={active.id === t.id}
              className={[styles.tab, active.id === t.id && styles.tabActive].filter(Boolean).join(' ')}
              onClick={() => setTab(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>
        <div className={styles.panel} role="tabpanel">
          {active.note && <p className={styles.note}>{active.note}</p>}
          {(active.lead || active.specs) && (
            <div className={styles.specBlock}>
              {active.lead && <p className={styles.lead}>{active.lead}</p>}
              {active.specs && (
                <ul className={styles.specList}>
                  {active.specs.map(([label, value]) => (
                    <li className={styles.specRow} key={label}>
                      <span className={styles.specLabel}>{label}</span>
                      <span className={styles.specValue}>{value}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
          {active.items && (
            <ul className={styles.checkList}>
              {active.items.map((it) => (
                <li className={styles.checkItem} key={it}><Tick/><span>{it}</span></li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </section>
  )
}

export default Gt2Compatibility
